$(document).on("submit", "[data-type='coupon-form'] form", function(event) {
  event.preventDefault();
  const form = $(this);
  const submitButton = form.find('[type="submit"]');
  const formData = form.serialize();
  const formAction = form.attr("action") || "";
  const locale = formAction.split("/")[1] || "en-EU";

  $.ajax({
    url: `/${locale}/orders/new.json`,
    type: "GET",
    data: formData,
    dataType: "json",
    success: function(response) {
      if (response.manual_discount) {
        if (response.guaranteed) {
          $("[data-type~=guarantee]").slideDown();
          $(".discount-code-guaranteed").html(response.discount_code);
          $(".guarantee-explanation").html(response.guarantee_explanation);
          $(".guarantee-agree-to-terms").html(response.guarantee_agree_to_terms);
          if (response.guarantee_not_fully_used) {
            $(".guarantee-not-full-title").html(response.guarantee_not_fully_used_title);
            $(".guarantee-not-full-text").html(response.guarantee_not_fully_used_text);
            $("[data-type~=guarantee-not-full]").slideDown();
          }
        } else {
          $("[data-type~=discount-show]").slideDown();
          $("[data-type~=discount-amount]").html(response.discount_amount);
          $("[data-type~=coupon-toggle]").slideDown();
          $("#discount-code").html(response.discount_code);
        }
        $("[data-type~=amount-due]").html(response.amount_due);
        $("[data-type~=coupon-form]").slideUp();
        $("[data-type~=payment-methods]").hide().html(response.payment_form_html).slideDown();
        $("[data-behavior~=update-payment-fees]").blur();
        $("[data-type~=payment-methods]").slideDown();
      } else {
        // Re-enable button when coupon is invalid
        submitButton.prop("disabled", false);
        $.flash("alert", response.coupon_invalid_msg || "Invalid coupon");
      }
    },
    error: function(xhr, status, error) {
      // Re-enable button when coupon is invalid
      submitButton.prop("disabled", false);
      console.error('AJAX Error:', status, error);
    }
  })
});
